export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5634.f5439329.jpg";